import React from 'react';
import {uploadOrganizationFile} from '../../services/api';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';

class UploaderField extends React.Component {
    constructor(props) {
        super(props);
        this.reset = this.reset.bind(this);
        this.uploadImage = this.uploadImage.bind(this);
    }

    async uploadImage(e) {
        const target = e.target;
        const files = Array.from(target.files);
        const result = await uploadOrganizationFile(files[0]);
        const url = result.data.url;
        this.props.form.setFieldValue(this.props.field.name, url);
    }

    reset() {
        this.props.form.setFieldValue(this.props.field.name, '');
    }

    render() {
        const {field: {value}, id} = this.props;
        return (
            <>
                <label htmlFor={id} className="col-form-label">
                    <FormattedMessage {...messages.admin.branding.logo} />
                </label>
                {value && (
                    <div>
                        <label htmlFor={id}>
                            <img src={value} className="img-thumbnail" style={{maxHeight: 200, maxWidth: 700}} />
                        </label>
                    </div>
                )}
                <input type="file" id={id} className="form-control-file" onChange={this.uploadImage} accept="image/*" />
                {value && (<a onClick={this.reset} className="text-danger">
                    <small><FormattedMessage {...messages.admin.branding.removeLogo} /></small>
                </a>)}
            </>
        );
    }
}

export default UploaderField;
